<template>
  <WdsStack direction-column gap-md>
    <WdsCollapse v-model:open="show" :content-id="`filters-${group.toString()}`">
      <template #title>
        <WdsStack v-if="group !== FilterGroups.NoGroup" justify-space-between align-center>
          <WdsStack align-center gap-sm>
            <WdsText tertiary>
              {{ group.toString().toUpperCase() }}
            </WdsText>

            <WdsButton
              v-if="filterValueCount > 0"
              secondary
              rounded
              sm
              @click.stop="resetLocalFilters"
            >
              <WdsStack justify-center align-center gap-xs>
                <div>{{ filterValueCount }}</div>
                <WdsIcon name="close" :size="16" />
              </WdsStack>
            </WdsButton>
          </WdsStack>
          <WdsButtonIcon sm transparent-background @click.stop="show = !show">
            <WdsIcon
              class="tw-transition-all"
              :class="{ 'tw-rotate-0': !show, 'tw-rotate-180': show }"
              name="chevron-up"
              :size="16"
            />
          </WdsButtonIcon>
        </WdsStack>
        <WdsDivider v-if="group !== FilterGroups.NoGroup" class="tw-mb-4" />
        <span v-else></span>
      </template>
      <template #content>
        <div v-if="model" class="filter-group">
          <GraphqlDataTableFilter
            v-for="arg of filters"
            :key="arg.filter.inputArgName"
            v-model="model[arg.filter.inputArgName]"
            :arg="arg"
          />
        </div>
      </template>
    </WdsCollapse>
  </WdsStack>
</template>

<script lang="ts" setup>
import {
  WdsButton,
  WdsButtonIcon,
  WdsCollapse,
  WdsDivider,
  WdsIcon,
  WdsStack,
  WdsText,
} from '@worksome/wds-components'
import { computed, ModelRef, ref } from 'vue'
import { FilterGroups } from '@/components/GraphqlDataTable/filters/filter-enums'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import GraphqlDataTableFilter from '@/components/GraphqlDataTable/filters/GraphqlDataTableFilter.vue'
import {
  countActiveFilters,
  resetFilters,
} from '@/components/GraphqlDataTable/filters/filter-tools'

const props = defineProps<{
  filters: FilterMetaDataProp[]
  group: FilterGroups
}>()

const model = defineModel<Record<string, any>>()

const show = ref(true)

const filterKeys = computed(() => props.filters.map(({ filter }) => filter.name))

const filterValueCount = computed(() =>
  countActiveFilters(filterKeys.value.map((key) => model.value?.[key])),
)

const resetLocalFilters = () => {
  if (model.value !== undefined) {
    resetFilters(
      model as ModelRef<Record<string, any>>, // We have checked for undefined above
      filterKeys.value,
    )
  }
}
</script>

<style lang="scss" scoped>
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 100%;
}
</style>
